<template>
  <div class="column">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <h2 class="subtitle" style="margin-bottom: 0.8rem;">
      {{ $t(`lockerDelivery.locker`) }}
      <b-icon icon="door-closed" style="position: relative; top: 2px;"></b-icon>
    </h2>

    <p>
      <b>{{ $t("lockerDelivery.name") }}:</b>
      {{ locker._id.lockerInfo.name || "-" }}
    </p>

    <p>
      <b>{{ $t("lockerDelivery.address") }}:</b>
      <a
        :href="
          `https://www.google.com/maps/search/?api=1&query=${
            locker._id.address.geolocation.coordinates[1]
          },${locker._id.address.geolocation.coordinates[0]}`
        "
        target="_blank"
      >
        {{
          `${locker._id.address.street}, ${locker._id.address.number}, ${
            locker._id.address.complement
              ? ` ${locker._id.address.complement}, `
              : ""
          }${locker._id.address.neighborhood}, ${locker._id.address.city}, ${
            locker._id.address.zipcode
          }`
        }}
      </a>
    </p>

    <p style="margin-top: 0.5rem;">
      <b>{{ $t("lockerDelivery.door") }}:</b>
      {{ locker.door._id.name || "-" }}
    </p>

    <p>
      <b>{{ $t("lockerDelivery.dimensions") }}:</b>
      {{
        `${
          locker.door._id.height
            ? `${$t("lockerDelivery.height")}: ${locker.door._id.height}cm, `
            : ""
        } ${
          locker.door._id.width
            ? `${$t("lockerDelivery.width")}: ${locker.door._id.width}cm, `
            : ""
        } ${
          locker.door._id.depth
            ? `${$t("lockerDelivery.depth")}: ${locker.door._id.depth}cm, `
            : ""
        } ${
          locker.door._id.heightFromGround
            ? `${$t("lockerDelivery.heightFromGround")}: ${
                locker.door._id.heightFromGround
              }cm`
            : ""
        }`
      }}
    </p>

    <button
      class="button is-small"
      :style="{
        backgroundColor: $primaryColor,
        color: $primaryColorContrast
      }"
      style="margin-top: 1rem"
      @click="askOpenDoor"
    >
      {{ $t("lockerDelivery.openDoor") }}
    </button>

    &nbsp;

    <button
      class="button is-deep-purple is-small"
      style="margin-top: 1rem"
      @click="askCancelDelivery"
    >
      {{ $t("lockerDelivery.cancelDelivery") }}
    </button>

    &nbsp;

    <button
      class="button is-small action-button"
      style="margin-top: 1rem"
      @click="$emit('edit-info')"
    >
      {{ $t("lockerDelivery.editInfo") }}
    </button>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  props: ["locker", "deliveryId"],

  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    askCancelDelivery() {
      this.$buefy.dialog.confirm({
        message: this.$t("lockerDelivery.sureWantToCancelDelivery"),
        confirmText: this.$t("common.yes"),
        cancelText: this.$t("common.no"),
        onConfirm: () => this.cancelDelivery()
      });
    },

    cancelDelivery() {
      this.isLoading = true;
      this.$store
        .dispatch("cancelDelivery", {
          deliveryId: this.deliveryId
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("get-locker-deliveries");
            this.$parent.$parent.close();
            this.$buefy.toast.open({
              message: this.$t("common.success"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    askOpenDoor() {
      this.$buefy.dialog.confirm({
        message: this.$t("lockerDelivery.sureWantToOpenDoor"),
        confirmText: this.$t("common.yes"),
        cancelText: this.$t("common.no"),
        onConfirm: () => this.openDoor()
      });
    },

    openDoor() {
      this.isLoading = true;
      this.$store
        .dispatch("openDoor", {
          deliveryId: this.deliveryId
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$emit("get-locker-deliveries");
            this.$buefy.toast.open({
              message: this.$t("common.success"),
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>
